import { render, staticRenderFns } from "./Edit-campaign.vue?vue&type=template&id=3266fdab&"
import script from "./Edit-campaign.vue?vue&type=script&lang=js&"
export * from "./Edit-campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports